import { Box, Button, Text, config, toRem } from 'folds';
import { Code, menuIcon } from '$components/icons/phosphor';
import { Page, PageHero, PageHeroSection } from '$components/page';
import { versionLabel } from '$utils/platform';
import LogoSVG from '$public/res/svg/logo.svg';

export function WelcomePage() {
  return (
    <Page>
      <Box
        grow="Yes"
        style={{ padding: config.space.S400, paddingBottom: config.space.S700 }}
        alignItems="Center"
        justifyContent="Center"
      >
        <PageHeroSection>
          <PageHero
            icon={<img width="70" height="70" src={LogoSVG} alt="Sedna logo" />}
            title="Welcome to Sedna"
            subTitle={
              <span>
                Space for conversation{' '}
                <a
                  href="https://gitlab.com/outermost/sedna"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {versionLabel()}
                </a>
              </span>
            }
          >
            <Box justifyContent="Center">
              <Box grow="Yes" style={{ maxWidth: toRem(300) }} direction="Column" gap="300">
                <Button
                  as="a"
                  href="https://gitlab.com/outermost/sedna"
                  target="_blank"
                  rel="noreferrer noopener"
                  before={menuIcon(Code)}
                >
                  <Text as="span" size="B400" truncate>
                    Source Code
                  </Text>
                </Button>
              </Box>
            </Box>
          </PageHero>
        </PageHeroSection>
      </Box>
    </Page>
  );
}
